import { Component, ViewEncapsulation, HostListener } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Menu, NavService } from '../../services/nav.service';
import { LayoutService } from '../../services/layout.service';
import { LogService } from '../../services/log.service';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SidebarComponent {
    userRoleName: string = '';

    public iconSidebar;
    public menuItems: Menu[];


    public margin: any = 0;
    public width: any = window.innerWidth;
    public leftArrowNone: boolean = true;
    public rightArrowNone: boolean = false;

    constructor(private readonly router: Router, public navServices: NavService,
        public layout: LayoutService, private readonly logService: LogService) {
        this.navServices.items.subscribe(menuItems => {
            this.menuItems = menuItems;
            this.routerEventSubscribe(menuItems);
        });

    }

    routerEventSubscribe(menuItems) {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.menuItemFilter(menuItems, event)
            }
        });
    }

    menuItemFilter(menuItems, event) {
        menuItems.filter(items => {
            if (items.path === event.url) {
                this.setNavActive(items);
            }
            if (!items.children) { return false; }
            this.childMenuFilter(items, event);
        });
    }

    childMenuFilter(items, event) {
        items.children.filter(subItems => {
            if (subItems.path === event.url) {
                this.setNavActive(subItems);
            }
            if (!subItems.children) { return false; }
            subItems.children.filter(subSubItems => {
                if (subSubItems.path === event.url) {
                    this.setNavActive(subSubItems);
                }
            });
        });
    }


    ngOnInit() {

        this.logService.getUserRoleName().subscribe((roleName) => {
            this.userRoleName = roleName;
        });
    }
    checkRole(role: string[]): boolean {
        if (!role || role.length === 0) {
            return true;
        }
        return role.includes(this.userRoleName);
    }


    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.width = event.target.innerWidth - 500;
    }

    sidebarToggle() {
        this.navServices.collapseSidebar = !this.navServices.collapseSidebar;
    }


    setNavActive(item) {
        this.menuItems.forEach(menuItem => {
            if (menuItem !== item) {
                menuItem.active = false;
            }
            if (menuItem.children?.includes(item)) {
                menuItem.active = true;
            }
            if (menuItem.children) {
                menuItem.children.forEach(submenuItems => {
                    if (submenuItems.children?.includes(item)) {
                        menuItem.active = true;
                        submenuItems.active = true;
                    }
                });
            }
        });
    }
    toggletNavActive(item) {
        if (!item.active) {
            this.menuItems.forEach(a => {
                if (this.menuItems.includes(item)) {
                    a.active = false;
                }
                if (!a.children) { return false; }
                a.children.forEach(b => {
                    if (a.children.includes(item)) {
                        b.active = false;
                    }
                });
            });
        }
        item.active = !item.active;
    }



    scrollToLeft() {
        if (this.margin >= -this.width) {
            this.margin = 0;
            this.leftArrowNone = true;
            this.rightArrowNone = false;
        } else {
            this.margin += this.width;
            this.rightArrowNone = false;
        }
    }

    scrollToRight() {
        if (this.margin <= -3051) {
            this.margin = -3464;
            this.leftArrowNone = false;
            this.rightArrowNone = true;
        } else {
            this.margin += -this.width;
            this.leftArrowNone = false;
        }
    }
}



